
import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_tenant_specific_product_color_size_details: { message: "idle" },
};

export const retrieve_tenant_specific_product_color_size_details_Slice = createSlice({
 name: "retrieve_tenant_specific_product_color_size_details",
 initialState,
 reducers: {
  success_retrieve_tenant_specific_product_color_size_details: (state, action) => {
   state.retrieve_tenant_specific_product_color_size_details = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_tenant_specific_product_color_size_details: (state, action) => {
   state.retrieve_tenant_specific_product_color_size_details = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_tenant_specific_product_color_size_details: (state) => {
   state.retrieve_tenant_specific_product_color_size_details = { status: app_consts.IDLE };
  },
  loading_retrieve_tenant_specific_product_color_size_details: (state) => {
   state.retrieve_tenant_specific_product_color_size_details = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_tenant_specific_product_color_size_details, fail_retrieve_tenant_specific_product_color_size_details, reset_retrieve_tenant_specific_product_color_size_details, loading_retrieve_tenant_specific_product_color_size_details } = retrieve_tenant_specific_product_color_size_details_Slice.actions;

export default retrieve_tenant_specific_product_color_size_details_Slice.reducer;